import ZTable, { ITableRef } from '@/components/ZTable';
import MainContent from '@/layouts/MainContent';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Tooltip, Button } from 'antd';
import { TicketIcon } from '@/assets/icons/entities/_';
import TicketsModal from './modals/tickets.modal';
import { PAGE_TITLE, columns, filters } from '.';
import { sumBy } from 'lodash';
import { BookingPagingDto } from '@/__generated';

const width = sumBy(columns, x => x.width || 0);
export default function SellOnTheGoBookingPage() {
  const { t } = useTranslation();
  const zTb = React.useRef<ITableRef>();
  const [displayTicketsModal, setDisplayTicketsModal] = React.useState<BookingPagingDto>();

  return (
    <MainContent title={t(PAGE_TITLE)}>
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <ZTable<BookingPagingDto>
          columns={columns}
          primaryKey="id"
          tableRef={zTb}
          scroll={{ x: width }}
          url="/bookings/sell-on-the-go/get-bookings"
          bordered
          order_by="createdOn"
          order_by_asc={false}
          allowEdit={false}
          allowDelete={false}
          filters={filters}
          searchBtnAlignLeft
          actionColumnWidth={80}
          extraActions={[
            {
              render: record => {
                return (
                  <Tooltip title={t('bookingPage_ViewTickets')}>
                    <Button
                      size="small"
                      onClick={() => {
                        setDisplayTicketsModal(record);
                      }}
                      type="link"
                      icon={<TicketIcon style={{ height: 14 }} />}
                    />
                  </Tooltip>
                );
              },
            },
          ]}
        />
      </div>
      {displayTicketsModal ? <TicketsModal booking={displayTicketsModal} onClose={() => setDisplayTicketsModal(undefined)} /> : null}
    </MainContent>
  );
}
